module.exports = __webpack_public_path__ + "img/tonny-chopper.f51dd22e.gif";